export default __webpack_public_path__ + "static/media/workouttimes_1@2x.a97e1457.jpg";